import fromPairs from 'lodash/fromPairs';
import memoize from 'lodash/memoize';

type QueryType = [string, string];

export const getLocation = memoize((url?: string) => {
  const link = document.createElement('a');
  link.href = url || '';

  return {
    // thanks for more one ugly HACK IE
    // http://stackoverflow.com/questions/956233/javascript-pathname-ie-quirk
    pathname: `${link.pathname[0] !== '/' ? '/' : ''}${link.pathname}`,
    search: link.search,
    href: link.href,
    hash: link.hash,
  };
});

const pathsCache = {};

export const getPathFromURL = (url: string): string => {
  if (pathsCache[url] == null) {
    const location = getLocation(url);
    pathsCache[url] = `${location.pathname}${location.search}`;
  }
  return pathsCache[url];
};

// get django CSRF token value stored in the user cookies
export function getCSRFToken(): string | undefined {
  let cookieValue: string | undefined = undefined;
  const name = 'csrftoken';

  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }

  return cookieValue;
}

// get a query param, returns null if the given url is also null.
// if the url exists, but the param is missing, then its possible
// to give a default return value. Used when page is missing because it is 1
export function getQueryParam(
  url: null | string,
  param: string,
  defaultValue: null | string = null
): null | string {
  if (url === null) {
    return null;
  }
  const urlData = getLocation(url);
  // Convert query string to object
  const queries = urlData.search
    .replace(/^\?/, '')
    .split('&')
    .map<QueryType>((item) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [key, value, ...extra] = item.split('=', 2);
      return [key, value];
    });
  return fromPairs(queries)[param] || defaultValue;
}

export function getContentTypeAndObjectIdFromURL(url: string | null): {
  contentType: string | null;
  objectId: number | null;
} {
  if (url == null) {
    return {contentType: null, objectId: null};
  }
  const urlPattern =
    /\/(procedures|policy|groups)\/[\w\d]+\/[\w\d-]+\/version\/(\d+)\//;
  const match = url.match(urlPattern);

  if (match) {
    const [, type, objectId] = match;

    let contentType = '';
    switch (type) {
      case 'procedures':
        contentType = 'procedureversion';
        break;
      case 'policy':
        contentType = 'policyversion';
        break;
      case 'groups':
        contentType = 'processversion';
        break;
      default:
        return {contentType: null, objectId: null};
    }

    return {
      contentType,
      objectId: Number(objectId),
    };
  }

  return {contentType: null, objectId: null};
}
